<template>
	<div>
		<b-modal 
			ref="saveAction" 
			id="saveAction" 
			:title="actionTitle"
            :ok-title="$t('misc.ok')" 
			:cancel-title="$t('misc.cancel')"
			size="md"
			@ok="saveAction"
			@hidden="clearSearches"
		>
			<div class="row">
				<div class="col-lg-12">
					<div class="row mb-3">
						<div class="col-lg-3">
							<label>{{ $t('table.isometric') }}</label>
						</div>
						<div class="col-lg-9">
							<multiselect v-model="selectedIsometric"
								:options="currentIsometrics"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isIsometricLoading"
								:preserve-search="true"
								placeholder=""
								label="info" track-by="id"
								:selectLabel="''"
								@search-change="onIsometricSearch"
								@input="updateIsometric"
							>
								<template slot="clear" slot-scope="props">
									<div 
										v-if="selectedIsometric != null" 
										class="multiselect__clear" 
										@mousedown.prevent.stop="clearSelectedIsometric"
									>
									</div>
								</template>
								<span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
								<span slot="noResult">{{ $t('modal.general.no_results') }}</span>
						</multiselect>
						</div>
					</div>

					<div class="row mb-3" v-if="model.drawing_id != null">
						<div class="col-lg-3">
							<label>{{ $t('table.weld') }}</label>
						</div>
						<div class="col-lg-9">
							<multiselect v-model="selectedWeld"
								:options="currentWelds"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isWeldLoading"
								:preserve-search="true"
								placeholder=""
								label="weld_no" track-by="id"
								:selectLabel="''"
								@search-change="onWeldSearch"
								@input="updateWeld"
							>
								<template slot="clear" slot-scope="props">
									<div 
										v-if="selectedWeld != null" 
										class="multiselect__clear" 
										@mousedown.prevent.stop="clearSelectedWeld"
									>
									</div>
								</template>
								<span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
								<span slot="noResult">{{ $t('modal.general.no_results') }}</span>
						</multiselect>
						</div>
					</div>

					<div class="row mb-3" v-if="model.drawing_id != null">
						<div class="col-lg-3">
							<label>{{ $t('table.testing_type') }}</label>
						</div>
						<div class="col-lg-9">
							<multiselect v-model="selectedTestingType"
								:options="testingTypesArray"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								placeholder=""
								label="name" track-by="code"
								:selectLabel="''"
							>
								<template slot="clear" slot-scope="props">
									<div 
										v-if="selectedTestingType != null" 
										class="multiselect__clear" 
										@mousedown.prevent.stop="clearSelectedTestingType"
									>
									</div>
								</template>
								<span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
								<span slot="noResult">{{ $t('modal.general.no_results') }}</span>
						</multiselect>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';

export default {
	name: 'WeldRequestModal',
	components: {
		notificationIcons,
		Multiselect,
	},
	props: {
        testingTypes: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
	data() {
		return {
			actionTitle: Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('general.welding.weld_requests.title'),
			tableNameTranslated: Vue.i18n.translate('general.welding.weld_requests.title2'),
			model: {
				drawing_id: null,
				weld_id: null,
				testing_type: null,
			},

			selectedIsometric: null,
            currentIsometrics: [],
            isIsometricLoading: false,

			selectedWeld: null,
            currentWelds: [],
            isWeldLoading: false,

			selectedTestingType: null,

			testingTypesArray: [],
		}
	},
	mounted() {
	},
	watch: {
		testingTypes: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
				if (typeof this.testingTypes != 'undefined' && this.testingTypes != null) {
					this.testingTypesArray = Object.values(this.testingTypes);
				}
            }
        }
	},
	methods: {
		successMsg(msg) {
			miniToastr.success(msg, Vue.i18n.translate('messages.success'));
		},
		errorMsg(msg) {
			miniToastr.error(msg, Vue.i18n.translate('messages.error'));
		},
		saveAction (e) {
			e.preventDefault();
			
			let put_data = {
				project_id:   this.$route.params.id,
				weld_id:      this.model.weld_id,
				testing_type: (this.selectedTestingType != null) ? this.selectedTestingType.code : null,
			};

			Object.keys(put_data).forEach(key => {
				if (put_data[key] === '') {
					put_data[key] = null;
				}
			});

			http.route('weld_request').post(put_data, true).then(response => {
				if (!response.isError) {
					this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
					this.hideModal();
				} else {
					Object.keys(response.errorMessage).forEach(key => {
						this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
					});
				}
			});
		},
		showModal () {
			this.$refs.saveAction.show();
		},
		hideModal () {
			this.$emit('onLoadTable');
			this.$emit('onLoadMainTable');
			this.$refs.saveAction.hide();
			this.clearSearches();
		},
		clearSearches () {
			this.clearSelectedIsometric();
			this.currentIsometrics = [];
			this.currentWelds      = [];
		},
		onIsometricSearch(search) {
            if (search == '') {
                this.currentIsometrics = [];
                
                return false;
            }

            this.isIsometricLoading = true;
            this.searchIsometrics(search, this);
        },
        searchIsometrics: _.debounce((search, vm) => {
            let data = http.route('drawing?project_id=' + vm.$route.params.id + '&search_select=' + search + '&filters[parent_drawing_id]=null&filters[discipline_id]='+1).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentIsometrics = response.data;
                }
                vm.isIsometricLoading = false;
            });
        }, 500),
		updateIsometric (isometric) {
			this.model.drawing_id = (isometric != null) ? isometric.id : null;
		},
		clearSelectedIsometric () {
			this.selectedIsometric = null;
			this.model.drawing_id = null;
			this.clearSelectedWeld();
			this.clearSelectedTestingType();
		},
		onWeldSearch(search) {
            if (search == '') {
                this.currentWelds = [];
                
                return false;
            }

			if (this.model.drawing_id != null) {
				this.isWeldLoading = true;
				this.searchWelds(search, this);
			}
        },
        searchWelds: _.debounce((search, vm) => {
            let data = http.route('weld?project_id=' + vm.$route.params.id + '&search_select=' + search + '&filters[parent_weld_id]=null&filters[drawing_id]='+ vm.model.drawing_id).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentWelds = response.data;
                }
                vm.isWeldLoading = false;
            });
        }, 500),
		updateWeld (weld) {
			this.model.weld_id = (weld != null) ? weld.id : null;
		},
		clearSelectedWeld () {
			this.selectedWeld = null;
			this.model.weld_id = null;
		},
		clearSelectedTestingType () {
			this.selectedTestingType = null;
			this.model.testing_type  = null;
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/global/modals/WeldRequestModal.vue